import { initializePublicPage } from "@/lib/publicPage";

initializePublicPage();

const headerRoot = document.getElementById("public-header-root");
const headerContext = document.getElementById("public-header-context");
if (headerRoot && headerContext) {
  void import("@/lib/publicHeader").then(({ mountPublicHeader }) => {
    mountPublicHeader(headerRoot, JSON.parse(headerContext.textContent ?? "{}"));
  }).catch(() => { /* The server-rendered navigation remains usable. */ });
}

const languageRoot = document.getElementById("public-language-root");
if (languageRoot) {
  void import("@/lib/publicHeader").then(({ mountPublicLanguageSelector }) => {
    mountPublicLanguageSelector(languageRoot, {
      current: document.documentElement.lang,
      csrfToken: document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? "",
    });
  }).catch(() => { /* The server-rendered language forms remain usable. */ });
}

// 記事の画面録画ブロック (広告ページの動画版)。無いページでは読み込まない
if (document.querySelector("figure[data-blog-video]")) {
  void import("@/lib/blogVideos").then(({ initBlogVideos }) => {
    initBlogVideos();
  }).catch(() => { /* The first-frame images remain visible. */ });
}

// 広告ページの登録ボタンのクリック計測 (Meta の最適化・画像版 / 動画版の比較用)
if (document.querySelector("[data-ad-variant]")) {
  void import("@/lib/adSignupClicks").then(({ initAdSignupClicks }) => {
    initAdSignupClicks();
  }).catch(() => { /* Links still work without measurement. */ });
}
